/*----------------------------------------------------------------------------
    RexDateNoTime.ts
    
    This is really just a RexDateTime, but the ToString() and CreateFromString
    will explicitly ignore time parts
----------------------------------------------------------------------------*/

import { RexDateTime } from "./RexDateTime";
import { DateParts } from "./DateParts";

export class RexDateNoTime extends RexDateTime
{
    public constructor(msecTotal: number)
    {
        super(msecTotal);
        this.m_dateTimeUtc = (this.removeTime() as RexDateNoTime).m_dateTimeUtc;
    }

    /*----------------------------------------------------------------------------
        %%Function: RexDateNoTime.createFromString

        make sure to adjust for any timezone information to make sure the date
        portion doesn't change
    ----------------------------------------------------------------------------*/
    public static createFromString(param: string | Date): RexDateNoTime
    {
        const local = (typeof param === "string") ? param : param.toISOString();

        const msecOffset = DateParts.msecOffsetFromString(local) ?? 0;
        const msec = (new Date(local)).valueOf();

        return new RexDateNoTime(msec + msecOffset);
    }

}